import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { UserUpdate } from 'app/models/user-update.model';
import { User } from 'app/models/user.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class UserService {

    user: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }

    resolve(): Observable<any> | Promise<any> | any {

        return new Promise<void>((resolve, reject) => {

            Promise.all([this.getUser()])
                .then(() => {
                    resolve()
                },
                    reject
                );
        });
    }


    getUser(): Promise<Array<User>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "users")
                .subscribe((response: any) => {
                    this.user = response;
                    this.onChanged.next(this.user);
                    resolve(response);
                }, reject);
        });
    }

    getUserCompany(compnayId: number): Promise<Array<User>> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "users/company/" + compnayId)
                .subscribe((response: any) => {
                    this.user = response;
                    this.onChanged.next(this.user);
                    resolve(response);
                }, reject);
        });
    }
    getByUser(userName: string): Promise<User> {

        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "users/getbyuser?username=" + userName)
                .subscribe((response: any) => {
                    this.user = response;
                    this.onChanged.next(this.user);
                    resolve(response);
                }, reject);
        });
    }

    add(entity: User): Promise<User> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "auth/register", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    updated(entity: UserUpdate): Promise<UserUpdate> {

        return new Promise((resolve, reject) => {

            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "auth/update", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    delete(entity: User): Promise<User> {
        return new Promise((resolve, reject) => {
            if (entity.picture != null) {
            this.ImageDelete(entity)
            }            
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "users/delete", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    ImageDelete(entity: User): Promise<User> {
        return new Promise((resolve, reject) => {
            var form = new FormData()
            form.append('Position', 'user')
            form.append('Picture', entity.picture)
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "upload/delete", form)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        })
    }
    upload(entity: FormData): Promise<File> {
        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "upload/user", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

}
